import { createAction, props } from '@ngrx/store';
import { cancelModalSourceTypes, CreateTypes } from '../utilities/Constants';

export const initializePage = createAction(
  '[Initialize-Page] Initialize store for specific page'
);

export const displayCancelModal = createAction(
  '[Cancel-Modal] Display cancel modal',
  props<{ nextUrlState: string, title?: string, content?: string[], greenButton?: string, grayButton?: string, isL1Nav?: boolean, isQuicklinksNav?: boolean, source: cancelModalSourceTypes }>()
);

export const hideCancelModal = createAction('[Cancel-Modal] Hide cancel modal');

export const resetCancelModal = createAction('[Cancel-Modal] Reset Cancel Modal');

export const resetCancelModalforInitiateAndReleaseTable = createAction('[Cancel-Modal] Reset Cancel Modal for Initiate and Release table');

export const cancelModalContinueClicked = createAction(
  '[Cancel-Modal] Continue clicked'
);

export const updateCorrelationId = createAction(
  '[Shared] Update correlation ID',
  props<{ correlationId: string, serviceCallUrl: string }>()
)

export const showEditingRestrictedModal = createAction(
  '[Editing-Restricted-Modal] Show Modal'
)

export const hideEditingRestrictedModal = createAction(
  '[Editing-Restricted-Modal] Hide Modal'
)

export const hideEditLinkConfirmationModal = createAction(
  '[Edit-Link-Confirmation-Modal] Hide Modal'
)

export const standingAuthComponentLoaded = createAction(
  '[Shared] Create standing authorization component loaded'
)

export const createRequestComponentLoaded = createAction(
  '[Shared] Create request component loaded'
)

export const initiateAndReleaseComponentLoaded = createAction(
  '[Shared] Initiate and Release component loaded'
)

export const hasEmptyResponse = createAction(
  '[Standing Authorizations Table] Empty response for table'
)

export const updateSelectedDate = createAction(
  '[Shared] Update Selected Date',
  props<{ newDate: string }>()
)

export const displayFilePickerModal = createAction(
  '[File-Picker] Display file picker modal',
  props<{ content?: string }>()
);

export const hideFilePickerModal = createAction(
  '[File-Picker] Hide file picker modal'
);

export const updatePreviousContext = createAction(
  '[Shared] Update previous create type in context',
  props<{ createType: CreateTypes }>()
);

export const previousContextNavigation = createAction(
  '[Shared] clearing previous context'
);

export const currentContextUpdated = createAction(
  '[Shared] current context updated'
);
